/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FlaggedItemObjectType,
    FlaggedItemObjectTypeFromJSON,
    FlaggedItemObjectTypeFromJSONTyped,
    FlaggedItemObjectTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserNotificationResponseDto
 */
export interface UserNotificationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UserNotificationResponseDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationResponseDto
     */
    flaggedItemId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationResponseDto
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationResponseDto
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationResponseDto
     */
    firmId?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserNotificationResponseDto
     */
    createdDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationResponseDto
     */
    resolvingUserId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UserNotificationResponseDto
     */
    resolutionDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserNotificationResponseDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {FlaggedItemObjectType}
     * @memberof UserNotificationResponseDto
     */
    type?: FlaggedItemObjectType;
}

export function UserNotificationResponseDtoFromJSON(json: any): UserNotificationResponseDto {
    return UserNotificationResponseDtoFromJSONTyped(json, false);
}

export function UserNotificationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserNotificationResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'flaggedItemId': !exists(json, 'flaggedItemId') ? undefined : json['flaggedItemId'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'firmId': !exists(json, 'firmId') ? undefined : json['firmId'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'resolvingUserId': !exists(json, 'resolvingUserId') ? undefined : json['resolvingUserId'],
        'resolutionDate': !exists(json, 'resolutionDate') ? undefined : (json['resolutionDate'] === null ? null : new Date(json['resolutionDate'])),
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'type': !exists(json, 'type') ? undefined : FlaggedItemObjectTypeFromJSON(json['type']),
    };
}

export function UserNotificationResponseDtoToJSON(value?: UserNotificationResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'flaggedItemId': value.flaggedItemId,
        'text': value.text,
        'userId': value.userId,
        'firmId': value.firmId,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'resolvingUserId': value.resolvingUserId,
        'resolutionDate': value.resolutionDate === undefined ? undefined : (value.resolutionDate === null ? null : value.resolutionDate.toISOString()),
        'isArchived': value.isArchived,
        'type': FlaggedItemObjectTypeToJSON(value.type),
    };
}


